import { Injectable } from '@angular/core';
import { FieldType } from '@sla-ng/ui-material';
import { distinctUntilChanged } from 'rxjs';
import { map } from 'rxjs/operators';
import { ICostCenterCostHistoryDialogLayout } from '../../models/layout/cost-center-cost-history-dialog-layout.model';
import { ICostCenterCostLayout } from '../../models/layout/cost-center-cost-layout.model';
import { IRebookingDialogLayout } from '../../models/layout/rebooking-dialog-layout.model';
import { ICostCenterCostRebookingState } from '../facades/cost-accounting/cost-center-cost-rebooking-state.model';
import { CostCenterCostRebookingFacade } from '../facades/cost-accounting/cost-center-cost-rebooking.facade';

@Injectable({
    providedIn: 'root',
})
export class RebookingLayoutService {

    constructor(protected myRebookingFacade: CostCenterCostRebookingFacade) {
    }

    public getCostCenterCostLayout(): ICostCenterCostLayout {
        return {
            costCenterCostColumns: [ 'costCenterName', 'costCt' ],
            distributionsColumns: [ 'costTypeName', 'distributionCost', 'actions' ],
        };
    }

    public getCostCenterCostHistoryDialog(): ICostCenterCostHistoryDialogLayout {
        return {
            inflowColumns: [ 'emittingCostCenter', 'emittingCostType', 'momentOfCalculation', 'valueCt' ],
            outflowColumns: [ 'receivingCostCenter', 'receivingCostType', 'momentOfCalculation', 'valueCt' ],
        };
    }

    public getRebookingDialogLayout(): IRebookingDialogLayout {
        return {
            sourceFields: [
                {
                    type: FieldType.text,
                    label: 'app.dialog.rebooking.source-cost-center.label',
                    field: 'costCenter',
                    readonly: true,
                    disabled: true,
                },
                {
                    type: FieldType.text,
                    label: 'app.dialog.rebooking.source-cost-type.label',
                    field: 'costType',
                    readonly: true,
                    disabled: true,
                },
                {
                    type: FieldType.decimal,
                    label: 'app.dialog.rebooking.value.label',
                    field: 'value',
                },
            ],
            targetFields: [
                {
                    type: FieldType.select,
                    label: 'app.dialog.rebooking.target-cost-center.label',
                    field: 'targetCostCenterId',
                    required: true,
                    selectData: {
                        valueKey: 'id',
                        labelKeys: [ 'name' ],
                        displaySearch: true,
                        options: this.myRebookingFacade.subState()
                            .pipe(
                                map((state: ICostCenterCostRebookingState) => state.targetCostCenters),
                                distinctUntilChanged((prev, curr) => JSON.stringify(prev) === JSON.stringify(curr)),
                            ),
                    },
                },
                {
                    type: FieldType.select,
                    label: 'app.dialog.rebooking.secondary-cost-type.label',
                    field: 'secondaryCostTypeId',
                    required: true,
                    selectData: {
                        valueKey: 'id',
                        labelKeys: [ 'name' ],
                        displaySearch: true,
                        options: this.myRebookingFacade.fetchSecondaryCostTypes(),
                    },
                },

            ],
        };
    }

}
